import { AccessCodes } from '@pm2/api';

function extractResourceGroups(resources) {
  var _a, _b;
  const resourceGroups = [];
  const ungroupedResourceDescriptor = {
    id: "ungrouped",
    accessCode: AccessCodes.ALLOWED,
    kind: "Group",
    title: "Ugrupperet",
    children: []
  };
  for (const resource of resources) {
    if (resource.kind === "Group") {
      resourceGroups.push(resource);
    } else {
      (_a = ungroupedResourceDescriptor.children) == null ? void 0 : _a.push(resource);
    }
  }
  if (((_b = ungroupedResourceDescriptor.children ?? []) == null ? void 0 : _b.length) > 0) {
    resourceGroups.push(ungroupedResourceDescriptor);
  }
  return resourceGroups;
}

export { extractResourceGroups };
//# sourceMappingURL=resource.extract-groups.js.map
